import getBrandFlag from './getBrandFlag';

const getNoImageFoundImageId = (brand) => {
  const brandFlag = getBrandFlag(brand);
  return `KIC_${brandFlag}XX-XXXX-XXXX-XXX`;
};

export default getNoImageFoundImageId;
